/** Shared request metadata for bounded, server-backed data grids. */
import { z } from 'zod';
export const SortDirection = {
    ASC: 'asc',
    DESC: 'desc',
};
export const SortDirectionSchema = z.enum(Object.values(SortDirection));
